import { render, staticRenderFns } from "./DRSTFooterBox.vue?vue&type=template&id=2e50e82a&"
import script from "./DRSTFooterBox.vue?vue&type=script&lang=ts&"
export * from "./DRSTFooterBox.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTFooterBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e50e82a')) {
      api.createRecord('2e50e82a', component.options)
    } else {
      api.reload('2e50e82a', component.options)
    }
    module.hot.accept("./DRSTFooterBox.vue?vue&type=template&id=2e50e82a&", function () {
      api.rerender('2e50e82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTFooterBox.vue"
export default component.exports